.certificationStatusPill {
    background-color: var(--certification-status-pill-background-color);
    color: var(--certification-status-pill-color);

    &.expired {
        background-color: var(--certification-status-pill-expired-background-color);
        color: var(--certification-status-pill-expired-color);
    }

    &.expiring {
        background-color: var(--certification-status-pill-expiring-background-color);
        color: var(--certification-status-pill-expiring-color);
    }

    &.valid {
        background-color: var(--certification-status-pill-valid-background-color);
        color: var(--certification-status-pill-valid-color);
    }
}

.statusDot {
    background-color: currentcolor;
    border-radius: var(--certification-status-pill-status-dot-border-radius);
    flex-shrink: 0;
    height: var(--certification-status-pill-status-dot-size);
    width: var(--certification-status-pill-status-dot-size);
}
